<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>员工信息导出</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="3">
          <el-date-picker style="width:98%;" v-model="startTime" size="small" type="date"
            placeholder="开始时间/在职导出截止时间"></el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-date-picker style="width:98%;" v-model="endTime" size="small" type="date" placeholder="结束时间">
          </el-date-picker>
        </el-col>
        <el-col :span="5">
          <el-button type="primary" size="small" @click="btnLeaveSearch" plain>离职搜索</el-button>
          <el-button type="success" size="small" @click="btnJoinSearch" plain>入职搜索</el-button>
          <el-button type="warning" size="small" @click="btnNowSearch" plain>在职搜索</el-button>
          <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
        </el-col>
        <el-col style="text-align:right;" :span="13">
          <el-button type="primary" size="small" @click="btnLeaveList" plain>离职人员导出</el-button>
          <el-button type="success" size="small" @click="btnJoinList" plain>入职人员导出</el-button>
          <el-button type="warning" size="small" @click="btnNowList" plain>在职人员导出</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="TableData" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="CompanyName" label="公司"></el-table-column>
            <el-table-column prop="CenterName" label="大中心"></el-table-column>
            <el-table-column prop="KernelName" label="小中心"></el-table-column>
            <el-table-column prop="MainDeptsName" label="部门"></el-table-column>
            <el-table-column prop="UserCode" label="工号"></el-table-column>
            <el-table-column prop="TrueName" label="姓名"></el-table-column>
            <el-table-column prop="PositionName" label="职务"></el-table-column>
            <el-table-column prop="DutyType" label="岗位类别"></el-table-column>
            <el-table-column prop="Duty" label="岗位"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount" style="float:right"></el-pagination>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { SysUserAllList, ExportedLeaveList } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
export default {
  data() {
    return {
      //   searchName: "",//姓名
      //   searchUserCode:'',//工号
      //   searchMainName:'',//部门
      startTime: '',//开始时间
      endTime: '',//结束时间
      TableData: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      currentRole: {},//当前登录角色
      currentUser: {},//当前登录人
      status: 3,//状态 1离职 2入职 3在职
    };
  },
  created() {
    //获取当前用户角色
    this.getCurrentRole()
    //获取当前用户
    this.getCurrentUser();

    this.GetUserAllPageList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetUserAllPageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetUserAllPageList();
    },
    //离职搜索
    btnLeaveSearch: function () {
      this.status = 1;
      this.pageIndex = 1;
      this.GetUserAllPageList();
    },
    //入职搜索
    btnJoinSearch: function () {
      this.status = 2;
      this.pageIndex = 1;
      this.GetUserAllPageList();
    },
    //在职搜索
    btnNowSearch: function () {
      this.status = 3;
      this.pageIndex = 1;
      this.GetUserAllPageList();
    },
    //刷新
    Refresh: function () {
      this.GetUserAllPageList();
    },
    //离职人员导出
    btnLeaveList: function () {
      if (this.startTime == '' || this.startTime == 'undefined' || this.startTime == null) {
        alert('请输入开始时间');
        return false;
      }
      if (this.endTime == '' || this.endTime == 'undefined' || this.endTime == null) {
        alert('请输入结束时间');
        return false;
      }
      //开始时间
      if (this.startTime != '' && this.startTime != null) {
        const contractStart = new Date(this.startTime);
        const contractStartTime = contractStart.getFullYear() + '-' + this.p((contractStart.getMonth() + 1)) + '-' + this.p(contractStart.getDate());
        this.startTime = contractStartTime;
      }
      //结束时间
      if (this.endTime != '' && this.endTime != null) {
        const contractEnd = new Date(this.endTime);
        const contractEndTime = contractEnd.getFullYear() + '-' + this.p((contractEnd.getMonth() + 1)) + '-' + this.p(contractEnd.getDate());
        this.endTime = contractEndTime;
      }
      // http://hr.text.ruizhiqi.com/
      window.location.href = "http://hr.text.ruizhiqi.com/publicApi/SysUserInfo/ExportedLeaveList/startTime/" + this.startTime + "/endTime/" + this.endTime + '/roleKey/' + this.currentRole.Key + '/userId/' + this.currentUser.UserId;
    },
    //入职人员导出
    btnJoinList: function () {
      if (this.startTime == '' || this.startTime == 'undefined' || this.startTime == null) {
        alert('请输入开始时间');
        return false;
      }
      if (this.endTime == '' || this.endTime == 'undefined' || this.endTime == null) {
        alert('请输入结束时间');
        return false;
      }
      //开始时间
      if (this.startTime != '' && this.startTime != null) {
        const contractStart = new Date(this.startTime);
        const contractStartTime = contractStart.getFullYear() + '-' + this.p((contractStart.getMonth() + 1)) + '-' + this.p(contractStart.getDate());
        this.startTime = contractStartTime;
      }
      //结束时间
      if (this.endTime != '' && this.endTime != null) {
        const contractEnd = new Date(this.endTime);
        const contractEndTime = contractEnd.getFullYear() + '-' + this.p((contractEnd.getMonth() + 1)) + '-' + this.p(contractEnd.getDate());
        this.endTime = contractEndTime;
      }
      // http://hr.text.ruizhiqi.com/     http://localhost:8011/
      window.location.href = "http://hr.text.ruizhiqi.com/publicApi/SysUserInfo/ExportedJoinList/startTime/" + this.startTime + "/endTime/" + this.endTime + '/roleKey/' + this.currentRole.Key + '/userId/' + this.currentUser.UserId;

    },
    //在职人员导出
    btnNowList: function () {
      console.log('在职人员导出');
      if (this.startTime == '' || this.startTime == 'undefined' || this.startTime == null) {
        alert('请输入开始时间');
        return false;
      }
      //开始时间
      if (this.startTime != '' && this.startTime != null) {
        const contractStart = new Date(this.startTime);
        const contractStartTime = contractStart.getFullYear() + '-' + this.p((contractStart.getMonth() + 1)) + '-' + this.p(contractStart.getDate());
        this.startTime = contractStartTime;
      }
      // http://hr.text.ruizhiqi.com/     http://localhost:8011/
      window.location.href = "http://hr.text.ruizhiqi.com/publicApi/SysUserInfo/ExportedNowList/startTime/" + this.startTime + '/roleKey/' + this.currentRole.Key + '/userId/' + this.currentUser.UserId;
    },
    //获取当前用户
    getCurrentUser: function () {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    //获取当前用户角色
    getCurrentRole: function () {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    GetUserAllPageList: function () {
      this.loading = true;
      //开始时间
      if (this.startTime != '' && this.startTime != null) {
        const contractStart = new Date(this.startTime);
        const contractStartTime = contractStart.getFullYear() + '-' + this.p((contractStart.getMonth() + 1)) + '-' + this.p(contractStart.getDate());
        this.startTime = contractStartTime;
      }
      //结束时间
      if (this.endTime != '' && this.endTime != null) {
        const contractEnd = new Date(this.endTime);
        const contractEndTime = contractEnd.getFullYear() + '-' + this.p((contractEnd.getMonth() + 1)) + '-' + this.p(contractEnd.getDate());
        this.endTime = contractEndTime;
      }

      SysUserAllList(
        this.pageIndex,
        this.pageSize,
        this.status,
        this.currentUser.UserId,
        this.currentRole.Key,
        this.startTime,
        this.endTime
      ).then(pageRes => {
        this.TableData = pageRes.List;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    //时间转换 不够10 添加0
    p(s) {
      return s < 10 ? '0' + s : s
    }
  }
};
</script>
<style scoped>
.redfont {
  color: red;
}
</style>